import { render, staticRenderFns } from "./StateroomDetail.vue?vue&type=template&id=db8d4258&scoped=true"
import script from "./StateroomDetail.vue?vue&type=script&lang=js"
export * from "./StateroomDetail.vue?vue&type=script&lang=js"
import style0 from "./StateroomDetail.vue?vue&type=style&index=0&id=db8d4258&prod&lang=less&scoped=true"
import style1 from "./StateroomDetail.vue?vue&type=style&index=1&id=db8d4258&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8d4258",
  null
  
)

export default component.exports